import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function ensureOk(response: Response): asserts response is Response {
  if (!response.ok) {
    throw new Error("Response is not ok.");
  }
}

export function humanReadableTimeDiff(date: Date): string {
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  const units = [
    { name: "year", plural: "years", prependSpace: true, seconds: 31536000 },
    { name: "month", plural: "months", prependSpace: true, seconds: 2592000 },
    { name: "day", plural: "days", prependSpace: true, seconds: 86400 },
    { name: "hour", plural: "hours", prependSpace: true, seconds: 3600 },
    { name: "m", plural: "m", prependSpace: false, seconds: 60 },
    { name: "s", plural: "s", prependSpace: false, seconds: 1 },
  ];

  for (const unit of units) {
    const count = Math.floor(diffInSeconds / unit.seconds);
    if (count > 0) {
      return count > 1
        ? `${count}${unit.prependSpace ? " " : ""}${unit.plural} ago`
        : `${count}${unit.prependSpace ? " " : ""}${unit.name} ago`;
    }
  }

  return "just now";
}

export function parseSemiIsoDateString(input: string): Date {
  //     YYYY MM DD  T HH MM SS  Z
  // e.g. 2022 11 24 T 08 12 14 Z
  return new Date(
    input.replace(
      /^(?<year>\d{4})(?<month>\d{2})(?<date>\d{2})T(?<hour>\d{2})(?<minutes>\d{2})(?<seconds>\d{2})Z$/,
      "$1-$2-$3T$4:$5:$6Z",
    ),
  );
}
